import request from "project-config/services/request/request";
export interface ICollectTransferUserBehaviorWebParams {
  userName?: string;
  behavior?: string;
  status?: string;
  version?: string;
  line?: string;
  failReason?: string;
}
export interface IGetTransferServerMsgParams {
  zone?: number;
  shareKey?: string;
}
export type IGetSoftPathParams = any;

export default {
  /**
   * 获得server
   */
  getTransferServerMsg(params: IGetTransferServerMsgParams, option?: any) {
    return request.post(
      "/api/rendering/task/transfer/getTransferServerMsg",
      params,
      option
    );
  },
  /**
   * 获得 文件 地址
   */
  getSoftPath(params: IGetSoftPathParams) {
    return request.post("/api/rendering/user/getSoftPath", params);
  },

  sendHeartBeat() {
    return request.post("/api/rendering/user/heartbeat");
  },
  // 用户行为数据
  collectTransferUserBehaviorWeb(
    params: ICollectTransferUserBehaviorWebParams
  ) {
    return request.post(
      "/api/rendering/task/transfer/collectTransferUserBehaviorWeb",
      params
    );
  },
};
